(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionDeleteController',RcopiaInstructionDeleteController);

    RcopiaInstructionDeleteController.$inject = ['$uibModalInstance', 'entity', 'RcopiaInstruction'];

    function RcopiaInstructionDeleteController($uibModalInstance, entity, RcopiaInstruction) {
        var vm = this;

        vm.rcopiaInstruction = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RcopiaInstruction.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
